export type TapeColour = 'pink' | 'sky' | 'green' | 'sunflower';
const TAPES: TapeColour[] = ['pink', 'sky', 'green', 'sunflower'];

const hash = (seed: string): number => {
    let h = 2166136261;
    for (let i = 0; i < seed.length; i++) h = Math.imul(h ^ seed.charCodeAt(i), 16777619);
    return h >>> 0;
};

// A stable angle per sticker, so cards keep their tilt across refreshes.
export const tilt = (seed: string, maxDegrees = 2): number =>
    ((hash(seed) % 2001) / 1000 - 1) * maxDegrees;

export const tapeColour = (seed: string): TapeColour => TAPES[hash(`${seed}:tape`) % TAPES.length];
